import { RadioGroup } from "@babackapp/customer-ui/components/radio-group";
import type { SingleFamilyLeaf } from "@babackapp/return-widget-components/lib/resolutions.lib";
import type { Resolution } from "@babackapp/return-widget-components/types";
import type { ReactNode } from "react";
import { BankTransferOption } from "./bank-transfer-option";
import { DiscountOption } from "./discount-option";
import { ExchangeCreditOption } from "./exchange-credit-option";

type Leaf = NonNullable<SingleFamilyLeaf>;

// When a family has a single, no-input option, it's shown directly on step 1
// using the option's own component instead of a generic family card. The user
// selects it and confirms, like any other resolution option.
const LEAF_OPTION: Record<Resolution, ReactNode> = {
  refund: <BankTransferOption selected={false} discountAvailable={false} />,
  discount: <DiscountOption />,
  "exchange-credit": <ExchangeCreditOption />,
  exchange: null, // never promoted — requires picking a variant first
};

// The RadioGroupItem value hardcoded inside each leaf option component.
const LEAF_RADIO_VALUE: Record<Resolution, string> = {
  refund: "bank-transfer",
  discount: "discount-code",
  "exchange-credit": "exchange-credit",
  exchange: "exchange",
};

type Props = {
  leaf: Leaf;
  selected: boolean;
  onSelect: () => void;
};

export function PromotedLeafTile({ leaf, selected, onSelect }: Props) {
  const value = LEAF_RADIO_VALUE[leaf.resolution];
  return (
    <RadioGroup value={selected ? value : ""} onValueChange={onSelect}>
      {LEAF_OPTION[leaf.resolution]}
    </RadioGroup>
  );
}
